export default __webpack_public_path__ + "static/media/vpayWoman.3097fa3f.png";